import React from "react";
import styles from "./Projects.module.css";

const Projects = () => {
  const projects = [
    {
      number: "01",
      title: "Launchpad App",
      description:
        "Token launch platform with live presale tracking, wallet integration, and real-time analytics. Enables users to participate in token launches with secure transactions and detailed market insights. Designed for crypto enthusiasts seeking early-stage investment opportunities.",
      tags: ["REACT", "CHARTS", "ANIMATIONS", "AUTH", "API", "WEB3"],
    },
    {
      number: "02",
      title: "StreamRank",
      description:
        "Streaming platform discovery tool that ranks movies and series by real IMDB ratings across Netflix, HBO, Disney+, Viaplay and more. Filter by country and platform to find what's actually worth watching. Features trailers, cast info, and similar recommendations.",
      tags: ["REACT", "VITE", "TMDB API", "OMDB API", "RESPONSIVE DESIGN", "VERCEL"],
    },
    {
      number: "03",
      title: "Side Hustle Hub",
      description:
        "Directory platform showcasing 30+ verified side hustle opportunities with real earnings data, searchable by category. Built with modern web stack for fast performance and beautiful dark/light mode UI.",
      tags: ["VITE", "REACT", "RESPONSIVE DESIGN", "VERCEL"],
    },
    {
      number: "04",
      title: "Crypto Tracker App",
      description:
        "Real-time portfolio dashboard with multi-chain support, price alerts, and detailed analytics.",
      tags: ["REACT", "REACT ROUTER", "API", "CHARTS", "WEB3"],
    },
    {
      number: "05",
      title: "Challenge Tracker",
      description:
        "Habit and goal tracking app with streak visualization, progress analytics, and insights.",
      tags: ["REACT", "REACT ROUTER", "ANIMATIONS", "VITE", "FIREBASE"],
    },
    {
      number: "06",
      title: "Camping Site App",
      description:
        "Full-stack booking platform for campsite reservations with interactive maps and real-time availability.",
      tags: ["HTML", "CSS", "JAVASCRIPT", "MONGODB", "FLEXBOX", "BOOTSTRAP"],
    },
  ];

  return (
    <>
      <div className={styles.divider}></div>
      <section id="work" className={styles.projects}>
        <div className={styles.container}>
          <span className={`${styles.label} mono`}>02 /</span>
          <h2 className={styles.title}>My Work</h2>

          <div className={styles.grid}>
            {projects.map((project) => (
              <div key={project.number} className={styles.card}>
                <div className={`${styles.number} mono`}>
                  {project.number} —
                </div>
                <h3 className={styles.cardTitle}>{project.title}</h3>
                <p className={styles.description}>{project.description}</p>
                <div className={styles.tags}>
                  {project.tags.map((tag) => (
                    <span key={tag} className={`${styles.tag} mono`}>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Projects;
